import React, {useEffect, useState} from 'react';
import {connect} from 'react-redux';
import PropTypes from 'prop-types';
import {withRouter} from 'react-router-dom';
import {Button, DescriptiveText, Page, TextInput, Tile} from '../../../../../shared';
import Row from '../../../../../shared/components/Row';
import Column from '../../../../../shared/components/Column';
import axiosInstance from '../../../../../shared/utils/axios';
import history from '../../../../../history';
import {_openModal} from '../../../../../shared/reducers/modals';
import {isAuthorized} from '../../../../../shared/reducers/user';

const SalesForceConfigure = (props) => {
  const {session, openModal} = props;
  const [firmConfiguration, setFirmConfiguration] = useState({
    loginURL: '',
    clientID: '',
    secret: '',
  });
  const disabled = !!session.profile.sfsInstance;
  const pattern = '^(https?:\\/\\/)?((([a-z\\d]([a-z\\d-]*[a-z\\d])*)\\.)+[a-z]{2,}|((\\d{1,3}\\.){3}\\d{1,3}))(:\\d+)?(\\/[-a-z\\d%_.~+]*)*(\\?[;&a-z\\d%_.~+=-]*)?(#[-a-z\\d_]*)?$';
  useEffect(() => {
    axiosInstance.get(`/firms/${session.profile.firm.id}/sfs`)
      .then(res => setFirmConfiguration({...res.data, loginURL: res.data.loginURL || res.data.defaultLoginURL}))
      .catch(err => openModal({
        type: 'Error',
        title: 'SalesForce',
        err,
      }));
  }, []);

  const updateFirmConfig = (name, value) => setFirmConfiguration({
    ...firmConfiguration,
    [name]: value,
  });
  const sfsFirmConfigure = event => {
    event.preventDefault();
    return axiosInstance.post(`/firms/${session.profile.firm.id}/sfs`, firmConfiguration)
      .then(() => history.push('/engage/sfs/connect/firm'))
      .catch(err => openModal({
        type: 'Error',
        title: 'SFS Firm Config Failed',
        err,
      }));
  };
  return <Page center='true'>
    <Tile key='Salesforce Firm Configuration' title='Salesforce Firm Configuration' width='650px'>
      <DescriptiveText>
        You can connect your firm with Salesforce Financial Services to have data sync between the two services and allow your
        advisors to single sign-on within {session.profile.brand.name}.
        Just fill in the fields below with information from Salesforce and then connect the firm to an admin user in Salesforce.
      </DescriptiveText>
      <form onSubmit={sfsFirmConfigure}>
        <Row wrap={false}>
          <Column width={'300'} layout={{grow: 1}}>
            <TextInput type={'Text'}
                       title={'Login URL:'}
                       placeholder={firmConfiguration.loginURL || 'Login URL'}
                       dataPoint={{
                         name: 'loginURL',
                         value: firmConfiguration.loginURL,
                       }}
                       required={true}
                       onChange={updateFirmConfig}
                       disabled={disabled}
                       autoFocus
                       validations={{pattern: pattern}}/>
            <TextInput type={'Text'}
                       title={'Client ID:'}
                       placeholder={'Client ID'}
                       dataPoint={{
                         name: 'clientID',
                         value: firmConfiguration.clientID,
                       }}
                       required={true}
                       onChange={updateFirmConfig}
                       disabled={disabled}/>
            <TextInput type={'Text'}
                       title={'Secret:'}
                       placeholder={'Secret'}
                       dataPoint={{
                         name: 'secret',
                         value: firmConfiguration.secret,
                       }}
                       required={true}
                       onChange={updateFirmConfig}
                       disabled={disabled}/>
          </Column>
        </Row>
        <Row wrap={false}>
          <Button importance={'primary'} size={'md'} label={'Cancel'} action={() => history.push('/integrations')}/>
          {isAuthorized(['FIRMMGR'])
          && <Button importance={'primary'}
                     size={'md'} label={'Connect Firm'}
                     action={'SUBMIT'}
                     disabled={disabled}/>}
          {session.profile.sfsInstance && !session.profile.sfsID
          && <Button importance={'primary'}
                     size={'md'}
                     label={'Connect Individual'}
                     action={() => history.push('/engage/sfs/individualConfigure')}/>}
        </Row>
      </form>
    </Tile>
  </Page>;
};

const mapStateToProps = state => ({
  session: state.session,
});

const mapDispatchToProps = (dispatch) => ({
  openModal: modalToOpen => dispatch(_openModal(modalToOpen)),
});

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(SalesForceConfigure));

SalesForceConfigure.propTypes = {
  /**
   * Is from Session Reducer
   */
  session: PropTypes.shape({profile: PropTypes.object}).isRequired,
  /**
   * The open modal function to dispatch _openModal from Redux
   */
  openModal: PropTypes.func.isRequired,
};
